import { LoadingListItem } from '../LoadingListItem';

export const LoadingListItemGroup = () => (
  <>
    <LoadingListItem />
    <LoadingListItem />
    <LoadingListItem />
  </>
);
